import React from "react";
import Layout from "./Layout";
import { useProps } from './useProps'

export const User = (params: { userId: App.User['id'] }) => <Layout {...useProps(params)} />
